export const getInitialMinBookingTimeType = (timeInSeconds) => {
  if (timeInSeconds === 0) return 'hours'
  const timeInMinutes = timeInSeconds / 60

  if (timeInMinutes % 60 !== 0) {
    return 'mins'
  }

  if ((timeInMinutes / 60) % 24 !== 0) {
    return 'hours'
  }

  return 'days'
}
